<template>
	<div class="page-navbar">
			<mt-navbar class="page-part" v-model="selected">
				<mt-tab-item id="1">监控分类</mt-tab-item>
				<mt-tab-item id="2">资源分组</mt-tab-item>
			</mt-navbar>
			<mt-tab-container v-model="selected">
				<mt-tab-container-item id="1" class="item01">
					<wc-tab-monitor :deviceData="deviceList" ref="monitor1" number=0></wc-tab-monitor>
				</mt-tab-container-item>
				<mt-tab-container-item id="2" class="item02">
					<wc-tab-monitor :deviceData="deviceList1" ref="monitor2" number=1></wc-tab-monitor>
				</mt-tab-container-item>
			</mt-tab-container>
	</div>
</template>
<script>
	import {_api} from '@/service/interface'
	export default{
		name:'WcMonitor',
		data(){
			return{
				selected:this.$route.query.s||'1',
				deviceList:[
					/*{name:'网络',list:[
						{status:1,IPaddress:"10.153.58.216",normal:Math.ceil(Math.random()*10),unnormal:Math.ceil(Math.random()*10)},
						{status:1,IPaddress:"10.153.58.12",normal:Math.ceil(Math.random()*10),unnormal:Math.ceil(Math.random()*10)},
						{status:0,IPaddress:"10.153.58.32",normal:Math.ceil(Math.random()*10),unnormal:0},
						{status:0,IPaddress:"10.153.58.178",normal:Math.ceil(Math.random()*10),unnormal:0},
						{status:0,IPaddress:"10.153.58.188",normal:Math.ceil(Math.random()*10),unnormal:0},
						{status:0,IPaddress:"10.153.58.32",normal:Math.ceil(Math.random()*10),unnormal:0}
					]},
					{name:'服务器',list:[
						{status:1,IPaddress:"10.153.58.110",normal:13,unnormal:Math.ceil(Math.random()*10)},
						{status:0,IPaddress:"127.15.21.25",normal:33,unnormal:0},
						{status:0,IPaddress:"10.153.26.35",normal:56,unnormal:0},
						{status:0,IPaddress:"10.153.25.178",normal:7,unnormal:0},
						{status:0,IPaddress:"10.153.47.94",normal:2,unnormal:0},
						{status:0,IPaddress:"10.158.54.98",normal:7,unnormal:0}
					]},
					{name:'存储',list:[
						{status:1,IPaddress:"10.153.58.78",normal:Math.ceil(Math.random()*10),unnormal:Math.ceil(Math.random()*10)},
						{status:1,IPaddress:"10.153.58.36",normal:Math.ceil(Math.random()*10),unnormal:0},
						{status:0,IPaddress:"10.153.58.32",normal:Math.ceil(Math.random()*10),unnormal:0},
						{status:0,IPaddress:"10.153.58.122",normal:Math.ceil(Math.random()*10),unnormal:0},
						{status:0,IPaddress:"10.153.58.148",normal:Math.ceil(Math.random()*10),unnormal:0},
						{status:0,IPaddress:"10.153.58.32",normal:Math.ceil(Math.random()*10),unnormal:0}
					]},
					{name:'关键业务',list:[
						{status:1,IPaddress:"10.153.58.216",normal:Math.ceil(Math.random()*10),unnormal:Math.ceil(Math.random()*10)},
						{status:1,IPaddress:"10.153.58.12",normal:Math.ceil(Math.random()*10),unnormal:Math.ceil(Math.random()*10)},
						{status:1,IPaddress:"10.153.58.32",normal:Math.ceil(Math.random()*10),unnormal:0},
						{status:0,IPaddress:"10.153.58.178",normal:Math.ceil(Math.random()*10),unnormal:0},
						{status:0,IPaddress:"10.153.58.188",normal:Math.ceil(Math.random()*10),unnormal:0},
						{status:0,IPaddress:"10.153.58.32",normal:Math.ceil(Math.random()*10),unnormal:0}
					]},
					{name:'其他',list:[
						{status:1,IPaddress:"10.153.58.216",normal:Math.ceil(Math.random()*10),unnormal:Math.ceil(Math.random()*10)},
						{status:0,IPaddress:"10.153.58.12",normal:Math.ceil(Math.random()*10),unnormal:0},
						{status:0,IPaddress:"10.153.58.32",normal:Math.ceil(Math.random()*10),unnormal:0}
					]},*/
				],
				deviceList1:[
					
				],
			}
		},
		methods:{
			calculateH(){
				//获取页面可视区域的高度
				var clientH = document.documentElement.clientHeight;
				//底部标题栏的高度
				var heardH = 45;
				//tab的高度
				var tabH = 44;
				//给页面内容区的高度赋值
				var item01 = document.getElementsByClassName("item01")[0];
				var item02 = document.getElementsByClassName("item02")[0];
				item01.style.height = clientH-heardH-tabH+"px";
				item02.style.height = clientH-heardH-tabH+"px";
			},
			onSwipeLeft(){
				this.selected="1";
				console.log("向左滑动成功");
			},
			onSwipeRight(){
				this.selected="2";
				console.log("向右滑动成功");
			},
			getAllMonitorType(){
				_api('_monitor','.code',{params:{mark:'allMonitorType'}},res=>{
					this.deviceList=[];
					res.data.forEach(item=>{
						this.deviceList.push({name:item.monitorTypeName,id:item.monitorType});
					})
					if(this.deviceList.length>0){
						let index=parseInt(this.$route.query.i)||0;
						this.$refs.monitor1.changeCur(index,this.deviceList[index])
					}
				},err=>{
					
				})
			},
			getAllGroupInfo(){
				_api('_monitor','.code',{params:{mark:'groupInfo'}},res=>{
					console.error(1111,res)
					this.deviceList1=[];
					res.data.forEach(item=>{
						this.deviceList1.push({name:item.groupName,id:item.groupId,groupId:item.groupId,subGroupId:item.subGroupId});
					})
					
					console.error(1111,this.$refs)
					if(this.deviceList1.length>0){
						let index=parseInt(this.$route.query.i)||0;
						this.$refs.monitor2.changeCur(index,this.deviceList1[index])
					}
				},err=>{
					
				})
			}
		},
		mounted:function(){
			this.calculateH();
			this.getAllMonitorType();
			this.getAllGroupInfo()
		}
	}
</script>
<style>
	body{
		width: 100%;
		height: 100%;
		background-size: 100% 100%;
	}
	/* .page-navbar{
		padding-top: 1px;
		position: relative;
		top: 45px;
		font-size: 14px;
	}
	.page-navbar .mint-navbar .mint-tab-item.is-selected{
		margin-bottom: 0;
		color: #029CCE;
		border-bottom: 3px solid #029CCE;
	}
	.page-navbar .mint-navbar .mint-tab-item{
		padding: 6px 0;
		border-bottom: 1px solid #D3D3D3;
	}
	.page-navbar .mint-tab-item-label{
		height: 25px;
		line-height: 25px;
		border-right: 1px solid #D3D3D3;
	}
	.page-navbar .mint-tab-item:last-child .mint-tab-item-label{
		height: 25px;
		line-height: 25px;
		border-right: 1px solid transparent;
	}
	.page-navbar .mint-tab-container-wrap{
		background:#F3F3F3;
	}
	.mint-tab-item-label{
		font-size:14px;
	} */
</style>


// WEBPACK FOOTER //
// src/components/monitor/index/WcMonitor.vue